import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-format-list-bulleted-icon',
  template: `
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_28155_25027)">
        <path
          d="
            M2.66602 7.5C2.11268 7.5 1.66602 7.94667 1.66602 8.5C1.66602 9.05333 2.11268 9.5 2.66602 9.5C3.21935 9.5 3.66602 9.05333 3.66602 8.5C3.66602 7.94667 3.21935 7.5 2.66602 7.5ZM
            2.66602 3.5C2.11268 3.5 1.66602 3.94667 1.66602 4.5C1.66602 5.05333 2.11268 5.5 2.66602 5.5C3.21935 5.5 3.66602 5.05333 3.66602 4.5C3.66602 3.94667 3.21935 3.5 2.66602 3.5ZM
            2.66602 11.5C2.11268 11.5 1.66602 11.9533 1.66602 12.5C1.66602 13.0467 2.11935 13.5 2.66602 13.5C3.21268 13.5 3.66602 13.0467 3.66602 12.5C3.66602 11.9533 3.21935 11.5 2.66602 11.5ZM
            4.66602 13.1667H13.9993V11.8333H4.66602V13.1667ZM
            4.66602 9.16667H13.9993V7.83333H4.66602V9.16667ZM
            4.66602 3.83333V5.16667H13.9993V3.83333H4.66602Z
          "
          [attr.fill]="'currentColor'"
        />
      </g>
      <defs>
        <clipPath id="clip0_28155_25027">
          <rect
            width="16"
            height="16"
            [attr.fill]="'currentColor'"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormatListBulletedIconComponent {}
